import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import { resetStore } from '../_core/resetStore';
import useAnalyticStore from '../analyticStore/useAnalyticStore';
import useApiStore from '../apiStore/useApiStore';
import useAttributionStore from '../attributionStore/useAttributionStore';
import useCoapplicantStore from '../coapplicantStore/useCoapplicantStore';
import useCookieStore from '../cookieStore/useCookieStore';
import useDashboardStore from '../dashboardStore/useDashboardStore';
import useLeadChannelStore from '../leadChannelStore/useLeadChannelStore';
import useMailCodeStore from '../mailCodeStore/useMailCodeStore';
import useUserStore from '../userStore/useUserStore';
import useWorkflowStore from '../workflowStore/useWorkflowStore';
import {
  applicantStore,
  currentIncomeKeys,
  currentResidenceKeys,
  keysToPersist,
  previousIncomeKeys,
  previousResidenceKeys,
} from './applicantStore';

const useApplicantStore = createStore({
  creator: applicantStore({
    resetStore,
    useAnalyticStore: lazyDependency(() => useAnalyticStore),
    useApiStore: lazyDependency(() => useApiStore),
    useAttributionStore: lazyDependency(() => useAttributionStore),
    useCoapplicantStore: lazyDependency(() => useCoapplicantStore),
    useCookieStore: lazyDependency(() => useCookieStore),
    useDashboardStore: lazyDependency(() => useDashboardStore),
    useLeadChannelStore: lazyDependency(() => useLeadChannelStore),
    useMailCodeStore: lazyDependency(() => useMailCodeStore),
    useUserStore: lazyDependency(() => useUserStore),
    useWorkflowStore: lazyDependency(() => useWorkflowStore),
  }),
  id: 'applicant',
  middlewares: {
    devtools: true,
    persist: {
      partialize(state) {
        if (!state.computed.isCurrentIncomePersisted) {
          keysToPersist.push(...currentIncomeKeys);
        }

        if (!state.computed.isPreviousIncomePersisted) {
          keysToPersist.push(...previousIncomeKeys);
        }

        if (!state.computed.isCurrentResidencePersisted) {
          keysToPersist.push(...currentResidenceKeys);
        }

        if (!state.computed.isPreviousResidencePersisted) {
          keysToPersist.push(...previousResidenceKeys);
        }

        return pickState(state, keysToPersist);
      },
    },
  },
  persistHMR: true,
});

export default useApplicantStore;
